import React from 'react';
import PropTypes from 'prop-types';
import ButtonIconV2 from '../common/ButtonIconV2';

import IconCart from './svg/IconCart';

function ButtonPlaylistCart({ onClick }) {
  return <ButtonIconV2
    className={'button-add-cart'}
    icon={<IconCart size={20} color={'#EF476F'} />}
    label={`Add to cart`}
    onClick={onClick}
  />
}

ButtonPlaylistCart.propTypes = {
  onClick: PropTypes.func.isRequired
}

export default ButtonPlaylistCart;
